export interface ChevronIconProps {
  /** `up` collapses the card, `down` expands it. */
  direction?: "up" | "down";
}

// The card disclosure marker. The ⌃/⌄ glyphs it replaces sat off-centre in most faces.
export default function ChevronIcon({ direction = "down" }: ChevronIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
      style={direction === "up" ? { transform: "rotate(180deg)" } : undefined}
    >
      <path d="M6 9.5l6 6 6-6" />
    </svg>
  );
}
